/**
 * FAQPage JSON-LD from text_block / text slices with include_in_faq_schema (Prismic).
 * @see https://developers.google.com/search/docs/appearance/structured-data/faqpage
 */
import {
  extractFaqPairsFromSlices,
  getFaqPageSchemaScript,
} from "~/utils/faq-schema";

export default {
  computed: {
    faqSchemaScripts() {
      const slices = this.slices ?? [];
      const script = getFaqPageSchemaScript(
        extractFaqPairsFromSlices(slices),
        this.uid || this.$route?.path || "faq"
      );

      return script ? [script] : [];
    },
  },
};
